import React from "react";
import { Button } from "views/components";
import confirmDeleteUser from "./DeleteUserModal";

class DeleteUserButton extends React.Component {
  render() {
    return (
      <div style={{ marginBottom: "12px" }}>
        <Button
          theme="redSolid"
          onClick={confirmDeleteUser({
            onOk: this.props.onDeleteUser
          })}
        >
          Delete Account
        </Button>
      </div>
    );
  }
}
export default DeleteUserButton;
